// assets/react/index.js
import { render } from '@wordpress/element';
import FoxLightbox from './fox-lightbox'; // The actual lightbox component
import domReady from '@wordpress/dom-ready';

domReady(() => {

	const container = document.getElementById('react-lightbox-container');
	if (container) {
		render(<FoxLightbox />, container);
	}

});